import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    primaryColor: {
      color: `${MaterialPalette.primary.main}`,
    },
    filesStyle: {
      margin: '0px 10px 10px 0px',
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'center',
      overflowWrap: 'anywhere',
    },
    assetfileName: {
      lineHeight: 1.35,
      justifyContent: 'space-between',
      display: 'inline',
    },
    downloadIcon: {
      marginRight: '4px',
      marginBottom: 'auto',
    },
    fileName: {
      display: 'inline',
    },
  }),
);

export default useStyles;
